import React from "react";

interface CookieIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const IdeaIcon: React.FC<CookieIconProps> = ({ size = 24, color = '#D68600', className, onClick }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0001 7.88965L10.9301 9.74965C10.6901 10.1596 10.8901 10.4996 11.3601 10.4996H12.6301C13.1101 10.4996 13.3001 10.8396 13.0601 11.2496L12.0001 13.1096" stroke="#D68600" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.29938 18.0401V16.8801C5.99938 15.4901 4.10938 12.7801 4.10938 9.90005C4.10938 4.95005 8.65938 1.07005 13.7994 2.19005C16.0594 2.69005 18.0394 4.19005 19.0694 6.26005C21.1594 10.4601 18.9594 14.9201 15.7294 16.8701V18.0301C15.7294 18.3201 15.8394 18.9901 14.7694 18.9901H9.25938C8.15938 19.0001 8.29938 18.5701 8.29938 18.0401Z" stroke="#D68600" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.5 22C10.79 21.35 13.21 21.35 15.5 22" stroke="#D68600" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>


);

export default IdeaIcon;
